import { lazy } from 'react';
import reducer from './state/reducers';
import { getStore } from '@AppRedux/store';
import checkAuth from '@Utils/checkAuth';
import Error404 from '../../Errors/404';

const store = getStore();

const SurveyForm = lazy(() =>
    import(/* webpackChunkName: "SurveyForm" */ './SurveyForm').then( module => {
        // wait for fetching userinfo before rendering
        store.injectReducer('surveyForm', reducer.surveyReducer);

        return module;
    })
);

const SurveyRoutes = [
    {
        label: 'Character Reference Survey Form',
        path: '/Survey/:refid/:mode',
        menuName: 'BackgroundCheck',
        component: SurveyForm,
        icon: 'fa-list',
        exact: true,
        showNav: true, //if true, displays the label in the mainHeader.js component
        public: true, // TODO: remove for private route
    }
]

export default SurveyRoutes;